import React from 'react';
import { motion } from 'framer-motion';
interface DiaryEntryProps {
  date: string;
  title: string;
  content: string;
  rotation?: number;
  delay?: number;
}
export function DiaryEntry({
  date,
  title,
  content,
  rotation = 0,
  delay = 0
}: DiaryEntryProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay
  }} className="relative w-full max-w-2xl mx-auto mb-12" style={{
    transform: `rotate(${rotation}deg)`
  }} data-id="element-55">
      {/* Tape effect */}
      <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-16 h-6 bg-white/60 backdrop-blur-sm border border-gray-200 shadow-sm z-10 transform -rotate-2" data-id="element-56"></div>

      <div className="bg-[#FFFCF8] paper-texture p-8 md:p-10 rounded-sm shadow-md border border-brown/10 relative z-0" data-id="element-57">
        <div className="flex flex-col md:flex-row md:items-baseline justify-between mb-4 border-b border-brown/20 pb-2" data-id="element-58">
          <h3 className="font-handwriting text-3xl text-forest font-bold" data-id="element-59">
            {title}
          </h3>
          <span className="font-handwriting text-xl text-brown/80" data-id="element-60">{date}</span>
        </div>
        <p className="font-serif text-gray-800 leading-loose text-lg whitespace-pre-line" data-id="element-61">
          {content}
        </p>
      </div>
    </motion.div>;
}